const emailAction = (state = "", action) => {
    switch(action.type) {
        case 'emailAction':
            return action.payload;
        default:
            return state;
    }
}

export default emailAction;